import * as angular from "angular";
import {IController, ILogService, IOnChangesObject} from "angular";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class CallSubTasksFormComponent implements IController {
  subTasks: any
  formName: any
  options: any;
  onAdd: Function;
  onRemove: Function;
  onSubTaskChange: Function;

  private isAddCustomSubTask: any;
  private customSubTaskTitle: any;
  private selectedSubTaskType: any;
  private editedSubTaskIndex: any;
  private cashOnDeliveryActionTypesMap: any;
  private actionOptions: any;
  public cashOnDeliveryActionMethods: any;

  /* @ngInject */
  constructor(private commonsService: CommonsService,
              private commonsConstants,
              private $log: ILogService,
              private SubTasksConstants,
              private WalletsConstants) {
  }

  $onInit() {
    this.cashOnDeliveryActionMethods = this.WalletsConstants.paymentTypes;

    this.cashOnDeliveryActionTypesMap = {
      Collect: true,
      Payment: true
    };

    this.actionOptions = this.SubTasksConstants.actionTypes;
  }

  onToggleMandatory(index, isMandatory) {
    const subTasksCopy = angular.copy(this.subTasks);
    subTasksCopy[index].mandatory = isMandatory;

    this.onSubTaskChange({subTask: subTasksCopy[index]});
  }

  onSubTaskTypeSelect(type, index) {
    const subTasksCopy = angular.copy(this.subTasks);
    subTasksCopy[index] = type;
    this.onSubTaskChange({subTask: subTasksCopy[index]});
  }

  onRemoveSubTask(subTask, index) {
    this.editedSubTaskIndex = undefined;
    this.onRemove({subtask: subTask, index: index})
  }

  onAddTemplate(subTaskOption) {
    this.onAdd({subtask: subTaskOption})
  }

  onAddEmptySubTask() {
    const subtask = {title: undefined, attachments: [], actions: []};
    this.onAdd({subtask: subtask});
  }

  onOptionsChange(subTask, options, index) {
    subTask.actions[index].dropdownOptions = options;
  }

  subTaskChange(index) {
    const subTasksCopy = angular.copy(this.subTasks);

    // this.onSubTasksChange({subTasks: subTasksCopy});
  }

  onSubTaskAddAction(action, subTaskIndex) {
    const subTasksCopy = angular.copy(this.subTasks);

    if (!subTasksCopy[subTaskIndex].actions) {
      subTasksCopy[subTaskIndex].actions = [];
    }
    subTasksCopy[subTaskIndex].actions.unshift(angular.copy(action));
    subTasksCopy[subTaskIndex].actions = this._getSubTaskActionsWithDefaults(subTasksCopy[subTaskIndex]);


    this.onSubTaskChange({subTask: subTasksCopy[subTaskIndex]});
  }

  onRemoveAction(subTaskIndex, actionIndex) {
    const subTasksCopy = angular.copy(this.subTasks);
    subTasksCopy[subTaskIndex].actions.splice(actionIndex, 1);
    this.onSubTaskChange({subTask: subTasksCopy[subTaskIndex]});
  }

  onServiceTimeChange(serviceTime, $index) {
    const subTasksCopy = angular.copy(this.subTasks);
    subTasksCopy[$index].serviceTime = serviceTime;
    this.onSubTaskChange({subTask: subTasksCopy[$index]});
  }

  onPdfFormTemplateChange(action, pdfFormTemplateId: string) {
    action.pdfFormTemplateId = pdfFormTemplateId;
  }

  onAddAttachment(subTaskIndex: number) {
    this.commonsService.fileUpload(this.commonsConstants.fileConstants.upload.images)
      .then((result) => {
        this._afterUpload(result, subTaskIndex);
      })
      .catch(() => {
        this.$log.info('Closed File Upload')
      })
  }

  onRemoveAttachment(subTaskIndex: number, attachmentIndex: number) {
    const subTasksCopy = angular.copy(this.subTasks);
    subTasksCopy[subTaskIndex].attachments.splice(attachmentIndex, 1);

    this.onSubTaskChange({subTask: subTasksCopy[subTaskIndex]});
  }

  _afterUpload(result, subTaskIndex: number) {
    const imageUrl: any = _.get(result, 'url');
    const mimeType: any = _.get(result, 'contentType');

    if (imageUrl) {
      const attachment = {
        url: imageUrl,
        mimeType: mimeType
      };

      const subTasksCopy = angular.copy(this.subTasks);

      if (!subTasksCopy[subTaskIndex].attachments) {
        subTasksCopy[subTaskIndex].attachments = [];
      }

      subTasksCopy[subTaskIndex].attachments.push(attachment);

      this.onSubTaskChange({subTask: subTasksCopy[subTaskIndex]});
    }
  }

  private _getSubTaskActionsWithDefaults(subTask) {
    if (!subTask.actions?.length) return [];

    return subTask.actions.map((a) => {
      if (this.cashOnDeliveryActionTypesMap[a.type]) {
        a.paymentMethods = a.paymentMethods?.length ? a.paymentMethods : [{
          method: undefined,
          requestAmount: undefined,
          editable: true
        }];
      }
      return a;
    });
  }

  onChangeTotalAmount(action, subTask) {
    action.paymentMethods[0].requestAmount = action.totalPrice;
    this.onSubTaskChange({subTask: subTask});
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .component('callSubTasksForm', {
    require: {
      form: '^form'
    },
    bindings: {
      subTasks: '<',
      formName: '<',
      options: '<',
      onAdd: '&',
      onRemove: '&',
      onSubTaskChange: '&'
    },
    template: require('./call-sub-tasks-form.html').default,
    controller: CallSubTasksFormComponent
  });
